export enum ArtistVerified {
  BlueVerified = "blue-verified",
  RedVerified = "red-verified",
  NotVerified = "not-verified",
}
